export const {
  tenantId,
  clientId,
  graphqlUri,
  sentryDsn,
  scope,
  environment
} = (window as any)._env;